// extracted by mini-css-extract-plugin
export default {"PageLoader":"PageLoader_PageLoader__G-wv8"};